
class SearchParsingError extends Error {
    constructor(message) {
        super(message);
        this.name = "SearchParsingError";
    }

    toString() {
        return `${this.name}: "${this.message()}"`;
    }
}

export default SearchParsingError;


//////////////////
// WEBPACK FOOTER
// ./src/models/errors/SearchParsingError.js
// module id = HCR1
// module chunks = 1